import {NavLink} from "react-router-dom";
import React, { Fragment } from "react";

const AdminNav = () => (
  <Fragment>
  <div className="flex flex-col lg:flex-row gap-1">
    <NavLink
      to="/"
      exact
      className="px-3 py-2 text-sm font-medium text-neutral-700 hover:text-blue-600 hover:bg-neutral-100 rounded-lg transition-colors"
      activeClassName="text-blue-600 bg-blue-50"
    >
      Home
    </NavLink>
    <NavLink
      to="/about-us"
      exact
      className="px-3 py-2 text-sm font-medium text-neutral-700 hover:text-blue-600 hover:bg-neutral-100 rounded-lg transition-colors"
      activeClassName="text-blue-600 bg-blue-50"
    >
      About Us
    </NavLink>
    <NavLink
      to="/admin"
      exact
      className="px-3 py-2 text-sm font-medium text-neutral-700 hover:text-blue-600 hover:bg-neutral-100 rounded-lg transition-colors"
      activeClassName="text-blue-600 bg-blue-50"
    >
      Admin Portal
    </NavLink>
    <NavLink
      to="/sign-up"
      exact
      className="px-3 py-2 text-sm font-medium text-neutral-700 hover:text-blue-600 hover:bg-neutral-100 rounded-lg transition-colors"
      activeClassName="text-blue-600 bg-blue-50"
    >
      Signing Agent / Field Inspector Sign Up
    </NavLink>
  </div>
  </Fragment>
);

export default AdminNav;
